import React, { useState } from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Button,
  Alert,
  Paper,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import LogoutIcon from '@mui/icons-material/Logout';

const LogoutView: React.FC = () => {
  const [openDialog, setOpenDialog] = useState(false);
  const navigate = useNavigate();

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleLogout = () => {
    // Entferne das Token aus dem localStorage
    localStorage.removeItem('token');
    
    // Schließe den Dialog
    setOpenDialog(false);
    
    // Navigiere zur Login-Seite (oder Startseite)
    navigate('/login');
  };

  return (
    <Box sx={{ maxWidth: '100%' }}>
      <Box sx={{ mb: 3, display: 'flex', alignItems: 'center' }}>
        <LogoutIcon sx={{ mr: 1, color: 'primary.main' }} />
        <Typography variant="h5" component="h1">
          Abmelden
        </Typography>
      </Box>

      <Paper sx={{ p: 4, borderRadius: 2, mb: 4 }}>
        <Typography variant="h6" gutterBottom>
          Wollen Sie sich wirklich abmelden?
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          Wenn Sie sich abmelden, müssen Sie sich erneut anmelden, um auf die Plattform zugreifen zu können.
        </Typography>
        <Divider sx={{ my: 3 }} />
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            variant="contained"
            color="primary"
            startIcon={<LogoutIcon />}
            onClick={handleOpenDialog}
            sx={{ minWidth: 150 }}
          >
            Abmelden
          </Button>
        </Box>
      </Paper>

      {/* Bestätigungsdialog */}
      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>Abmelden bestätigen</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Sind Sie sicher, dass Sie sich abmelden möchten? Alle nicht gespeicherten Änderungen gehen verloren.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">
            Abbrechen
          </Button>
          <Button onClick={handleLogout} color="error" variant="contained">
            Abmelden
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default LogoutView; 